export const KLARO_ICON_PATHS = Object.freeze({
  home: '/assets/klaro/icons/home-menu.png',
  goodsReceipt: '/assets/klaro/icons/goods-receipt.png',
  goodsReceiptMenu: '/assets/klaro/icons/goods-receipt-menu.png',
  production: '/assets/klaro/icons/production.png',
  productionMenu: '/assets/klaro/icons/production-menu.png',
  warehouse: '/assets/klaro/icons/warehouse.png',
  warehouseMenu: '/assets/klaro/icons/warehouse-menu.png',
  recipes: '/assets/klaro/icons/recipes.png',
  recipesMenu: '/assets/klaro/icons/recipes-menu.png',
  expiry: '/assets/klaro/icons/expiry.png',
  expiryMenu: '/assets/klaro/icons/expiry-menu.png',
  labels: '/assets/klaro/icons/labels.png',
  labelsMenu: '/assets/klaro/icons/labels-menu.png',
  traceability: '/assets/klaro/icons/traceability.png',
  traceabilityMenu: '/assets/klaro/icons/traceability-menu.png',
  settings: '/assets/klaro/icons/settings-menu.png',
  settingsSliders: '/assets/klaro/icons/settings-sliders.png',
  haccpControls: '/assets/klaro/icons/haccp-controls.png',
  nonconformity: '/assets/klaro/icons/nonconformity.png',
  discharge: '/assets/klaro/icons/discharge.png',
  aiKlaro: '/assets/klaro/icons/ai-klaro.png',

  report: '/assets/klaro/icons/report.png',
  reportMenu: '/assets/klaro/icons/report-menu.png',
  archive: '/assets/klaro/icons/archive.png',
  support: '/assets/klaro/icons/support.png',
  products: '/assets/klaro/icons/products.png',
  ingredients: '/assets/klaro/icons/ingredients.png',
  ingredientsMenu: '/assets/klaro/icons/ingredients-menu.png',
  suppliers: '/assets/klaro/icons/suppliers.png',
  suppliersMenu: '/assets/klaro/icons/suppliers-menu.png',
  ddtOcr: '/assets/klaro/icons/ddt-ocr.png',
  batchAdvanced: '/assets/klaro/icons/batch-advanced.png',
  scannerQr: '/assets/klaro/icons/scanner-qr.png',
  allergens: '/assets/klaro/icons/allergens.png',
  allergensMenu: '/assets/klaro/icons/allergens-menu.png',
  print: '/assets/klaro/icons/print.png',
  pdfExport: '/assets/klaro/icons/pdf-export.png',
  search: '/assets/klaro/icons/search.png',
  filters: '/assets/klaro/icons/filters.png',
  usersRoles: '/assets/klaro/icons/users-roles.png',
  companyAccount: '/assets/klaro/icons/company-account.png',
  notifications: '/assets/klaro/icons/notifications.png',
  checklistAudit: '/assets/klaro/icons/checklist-audit.png',
  haccpRegisterMenu: '/assets/klaro/icons/haccp-register-menu.png',
  activityHistory: '/assets/klaro/icons/activity-history.png',
});

export const getKlaroIconPath = (name) => KLARO_ICON_PATHS[name] || null;
